import React from "react";
//import ReactDOM from 'react-dom';
import './App.css';

import {
  Switch,
  Route,
  Link,
  BrowserRouter
} from "react-router-dom";
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
//import {makeStyles} from '@material-ui/core'
//import Typography from '@material-ui/core/Typography';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import profilepic from './dabhoang.jpg';
import gradday from './grad.jpg';
//import Icon from '@material-ui/core/Icon';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import AssignmentIcon from '@material-ui/icons/Assignment';
import resume from './DanHoang_Resume.pdf';
import {useEffect} from "react";

// This site has 3 pages, all of which are rendered
// dynamically in the browser (not server rendered).
//
// Although the page does not ever refresh, notice how
// React Router keeps the URL up to date as you navigate
// through the site. This preserves the browser history,
// making sure things like the back button and bookmarks
// work properly.


const tablabel = createTheme({
  typography: {
    fontFamily: 'Arial',
    button:{
      textTransform: 'none',
      fontSize: 16,
    }
  },
});



export default function App() {
  useEffect(() => {
     document.title = "Dan Hoang";  
   }, []);
  //const classes = useStyles()
  //componentDidMount() {
    //document.title = "Dan Hoang"; 
  //}
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <div>

        <AppBar position="static">
          
          <ThemeProvider theme={tablabel}>
          <Toolbar>

            

            <Grid justify={"center"} alignItems={"center"} container>
            <Tabs textColor="white" centered>
              <Tab label="Home" to="/" component={Link}/>
              <Tab label="About" to="/about" component={Link}/>
              <Tab label="Experience" to="/experience" component={Link}/>
              <Tab label="Projects" to="/projects" component={Link}/>
            </Tabs>
            </Grid>

            

          </Toolbar>
          </ThemeProvider>
        </AppBar>
        <hr />

        {/*
          A <Switch> looks through all its children <Route>
          elements and renders the first one whose path
          matches the current URL. Use a <Switch> any time
          you have multiple routes, but you want only one
          of them to render at a time
        */}
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/experience">
            <Experience />
          </Route>
          <Route path="/projects">
            <Projects />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
}

// You can think of these components as "pages"
// in your app.

function Home() {
  /*const openResume = () => {
    const link = document.createElement("a");
    link.download = `DanHoang_Resume.pdf`;
    link.href = "DanHoang_Resume.pdf";
    link.click();
  };*/

  /*const emaillabel = createTheme({
    typography: {
      fontFamily: 'Arial',
        button:{
        textTransform: 'none',
        fontSize: 16,
      }
    },
  });*/

  
  return (
        //<title>Dan Hoang</title>
        <div class="center">
          <h1>Dan Hoang</h1>
          <img src={profilepic} alt="Dan Hoang profile pic" width="400" height="400" class = "profpic"></img>
          <h2>Software Engineer with 2.5 YOE looking for my next opportunity</h2>
          <h2>Previously @ Brooks Automation and Orchestrade</h2>
          <h2>Computer Science M.S. graduate from University of California, Davis</h2>
          <h2>Computer Science B.S. graduate from University of California, Santa Cruz</h2>
          
          <Button variant="contained" href="https://www.linkedin.com/in/dabhoang/" color="primary" startIcon={<LinkedInIcon />}>
            LinkedIn
          </Button>
          <Button variant="contained" href={resume} color="primary" startIcon={<AssignmentIcon />}>
            Resume
          </Button>
          <Button variant="contained" href="https://github.com/dabhoang" color="primary" startIcon={<GitHubIcon />}>
            GitHub
          </Button>
          
          <br/>
          <h2>Contact:<br/>dabhoang24@gmail.com</h2>





        </div>
  );
}




function About() {
  return (
    <div class = "margined">
      <h1 class="center">About</h1>
        <p>Hi! I'm Dan Hoang and I'm currently looking for my next opportunity as a software engineer. I have 2.5 years of experience as a software engineer in the Microsoft stack, so I've used technologies such as C#, .NET, WPF, WinForms, and Azure DevOps Server. 
          I've previously worked as a software engineer at Brooks Automation and Orchestrade.
          I graduated with a Master of Science in Computer Science at University of California, Davis in September 2022, and 
        I graduated with a Bachelor of Science in Computer Science from University of California, Santa Cruz in June 2020 with Honors in the Major. 


        </p>
      <img src={gradday} alt="Dan Hoang grad" class="graddaypic"></img>
    </div>
  );
}





function Experience() {
  return (
    <div class = "margined">
      <h1 class="center">Experience</h1>
      <h2>Orchestrade</h2>
          <h3>Software Developer</h3>
          <h3>March 2024 - March 2025</h3>
          
            <ul>
              <li>Designed and implemented multi-user state transition logic for a 30+ billion dollar client’s financial workflows in the company’s enterprise trading platform consisting of a WinForms (C#) desktop application, .NET Core (C#) server application, and MS SQL database</li>
              <li>Developed a new plugin in the company’s main WinForms (C#) desktop application to enable automated export of trade data for 7 financial products from a MS SQL database to a CSV file and an XML file</li>
              <li>Maintained the company’s enterprise trading platform (WinForms, .NET Core, and MS SQL) for 7 clients and 9 financial products by debugging and fixing reported bugs, as well as designing and developing requested features</li>
            </ul>
        <br />
        <br />
        
        <h2>Brooks Automation</h2>
          <h3>Software Engineer</h3>
          <h3>Full Time: February 2023 - present</h3>
          
            <ul>
              <li>Streamlined 7 manufacturing procedures by designing and developing a WPF .NET GUI that uses the Model-View-ViewModel architecture pattern and sends commands to a FRU using the company’s API</li>
              <li>Ensured the software implementation of streamlined procedures meets hardware requirements by collaborating with the electrical team</li>
              <li>Designed and developed a feature to correctly detect a valid software license key for a C#/.NET server application that runs in the Linux operating system of the equipment front end module (EFEM) delivered to a customer ranked in the top 10 companies of the semiconductor industry according to multiple rankings</li>
              <li>Streamlined 3 additional manufacturing procedures by implementing REST API requests in C# to the company’s ASP.NET Core Web API server in order to receive the feed and set the settings of Raspberry Pi cameras</li>
              <li>Updated the company’s main RPC API to enable customers to clamp carriers onto additional configurations (specified in XML files) of EFEMs when using the company’s main WinForms (C#) desktop application</li>
              <li>Wrote test scripts using Python to automate test cases for developed features</li>
              <li>Contractor: October 2022 - February 2023 ; Full time: February 2023 - March 2024</li>
            </ul>
        <br />
        <br />

        <h2>Xtended Reality Labs - University of California, Davis</h2>
          <h3>Researcher (Volunteer)</h3>
          <h3>October 2021 - September 2022</h3>
            <ul>
              <li>Created a 3D virtual reality multiplayer game using Unity and C# where players move around to collect points</li>
              <li>Collaborated with other lab members to ensure the game is playable on the lab’s Oculus devices</li>
              <li>Collaborated with the professor and other lab members to ensure a smooth handoff so that the game is usable for the lab’s next objectives</li>
            </ul>
        <br />
        <br />

        <h2>UC Davis CS Department</h2>
          <h3>Teaching Assistant</h3>
          <h3>September 2021 - June 2022</h3>
            <ul>
              <li>Helped students with debugging programming assignments in C, C++, RISC-V assembly, and x86 assembly</li>
              <li>Provided explanations and answered student questions relating to the course content</li>
            </ul>
        <br />
        <br />

    </div>
  );
}





function Projects() {
  return (
    <div class = "margined">
      <h1 class="center">Projects</h1>


        <h2>To be announced</h2>
        <h3>Projects are currently in development</h3>

        


    </div>
  );
}

